import { render, staticRenderFns } from "./AdminTools.vue?vue&type=template&id=5a4884d8&scoped=true"
import script from "./AdminTools.vue?vue&type=script&lang=js"
export * from "./AdminTools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4884d8",
  null
  
)

export default component.exports